import BaseService from '_services/rest/base';
import { getDateISO } from '_utils';

class LeadService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/lead`;
  }

  getFilters(params) {
    return {
      ...params,
      date_to: getDateISO(params.date_to),
      date_from: getDateISO(params.date_from),
    };
  }

  getList(params) {
    const filters = this.getFilters(params);

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getLeadById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getResellersOptions() {
    return this.request(`${this.getUrl()}/resellers`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getCitiesOptions(state, city) {
    return this.request(`${this.getUrl()}/cities`, { state, city })
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  toggleSpam(id, status) {
    return this.request(`${this.getUrl()}/${id}/spam`, { status }, 'PATCH')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  toggleFinished(id, finished) {
    return this.request(`${this.getUrl()}/${id}/finished`, { finished }, 'PATCH')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  changeReseller(resellerId, leadId) {
    return this.request(`${this.getUrl()}/${leadId}/assign/${resellerId}`, null, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  download(params) {
    const filters = this.getFilters(params);

    return this.request(`${this.getUrl()}/download`, filters, 'get')
      .catch(err => {
        throw err;
      });
  }
}

export default new LeadService();
